export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/OH-60ee45bd28dcfe79b575b5bea288a83c.PNG";